import requestGHN from "../../config/axiosGHN";
import requestFee from "../../config/axiosFeeShip"
import request from "../../config/axios";
const getDistrictByProvinceID = (province_id) => {
  return requestGHN.get(
    `/shiip/public-api/master-data/district?province_id=${province_id}`
  );
};

const getWardByDistrictID = (district_id) => {
  return requestGHN.get(
    `/shiip/public-api/master-data/ward?district_id=${district_id}`
  );
};

const calculateShippingCost = ( )=>{
  return request.get(`/wp-json/ghn/v1/shipping-cost`)
}


const getCity = () => {
  return requestGHN.get(`/shiip/public-api/master-data/province`);
};

export {getCity, getDistrictByProvinceID, getWardByDistrictID , calculateShippingCost };
